import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/Navbar.css";
import Logo from "../img/spinoff-logo.png";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const handleMenuClick = () => {
    setActiveDropdown(null); // Close dropdown when a submenu item is clicked
    setIsMenuOpen(false); // Close mobile menu if open
  };

  return (
    <header className="site-header">
      <div className="headc">
        <ul
          className="list-unstyled e-p-bx"
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <li>
            <span>
              <i className="fas fa-envelope"></i> Mail:
            </span>{" "}
            sales@spinoff.in
          </li>
          <li>
            <span>
              <i className="fas fa-phone-alt"></i> Call:
            </span>{" "}
            +91 97780-44000
          </li>
          <li>
            <a
              href="https://www.facebook.com/SpinoffTechnoparkgroup/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#3b5998", fontSize: "20px", marginLeft: "25px" }}
            >
              <i className="fab fa-facebook"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/spinofftechnopark/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#e1306c", fontSize: "20px", marginLeft: "25px" }}
            >
              <i className="fab fa-instagram"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/spinofftechnopark/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0077b5", fontSize: "20px", marginLeft: "25px" }}
            >
              <i className="fab fa-linkedin"></i>
            </a>
          </li>
        </ul>
      </div>
      <div className="sticky-header main-bar">
        <div className="main-bar header-left-gray-block bg-white">
          <div className="container clearfix">
            <div className="logo-header">
              <div className="logo-header-inner logo-header-one">
                <Link to="/">
                  <img src={Logo} alt="Spinoff Logo" />
                </Link>
              </div>
            </div>

            <button
              id="mobile-side-drawer"
              onClick={toggleMenu}
              type="button"
              className={`navbar-toggler ${isMenuOpen ? "open" : ""}`}
              aria-expanded={isMenuOpen ? "true" : "false"}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>

            <div className={`header-nav ${isMenuOpen ? "show" : ""}`}>
              <div className="mobile-menu-header">
                <button className="close-button" onClick={handleMenuClick}>
                  &times;
                </button>
              </div>
              <ul className="nav navbar-nav">
                <li
                  className={activeDropdown === 0 ? "open" : ""}
                  onMouseEnter={() => setActiveDropdown(0)}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <Link to="/about-us" className="dropdown-toggle actbtn">
                    About Us
                  </Link>
                  <ul className="sub-menu">
                    {/*<li>
                      <Link to="/our-management" onClick={handleMenuClick}>
                        Our Management
                      </Link>
                    </li>*/}
                     <li>
                      <Link to="/our-team" onClick={handleMenuClick}>
                        Our Team
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-journey" onClick={handleMenuClick}>
                        Our Journey
                      </Link>
                    </li>
                   
                    <li>
                      <Link to="/our-infrastructure" onClick={handleMenuClick}>
                        Our Infrastructure
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/our-customers" onClick={handleMenuClick}>
                    Our Customers
                  </Link>
                </li>
                <li className={activeDropdown === 1 ? "open" : ""}>
                  <button
                    onClick={() => toggleDropdown(1)}
                    className="dropdown-toggle actbtn"
                    aria-expanded={activeDropdown === 1 ? "true" : "false"}
                  >
                    Business Verticals
                  </button>
                  <ul className="sub-menu">
                    <li>
                      <Link
                        to="/our-services/led-lights"
                        onClick={handleMenuClick}
                      >
                        LED Lights
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/our-services/lithium-battery"
                        onClick={handleMenuClick}
                      >
                        Lithium Battery
                      </Link>
                    </li>
                    <li>
                      <Link to="/Bess" onClick={handleMenuClick}>
                        Battery Energy Storage System
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/our-services/inverter-ups"
                        onClick={handleMenuClick}
                      >
                        Inverter & UPS
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/our-services/sheet-metal"
                        onClick={handleMenuClick}
                      >
                        Metal Engineering Profile
                      </Link>
                    </li>
                  </ul>
                </li>



             {/*   <li className={activeDropdown === 1 ? "open" : ""}>
                  <button
                    onClick={() => toggleDropdown(1)}
                    className="dropdown-toggle actbtn"
                    aria-expanded={activeDropdown === 1 ? "true" : "false"}
                  >
                    Investor Relations
                  </button>
                  <ul className="sub-menu">
                    <li>
                      <Link
                        to="/investor-relations/committee-of-board"
                        onClick={handleMenuClick}
                      >
                        Committee of Board
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/investor-relations/financials"
                        onClick={handleMenuClick}
                      >
                        Financials
                      </Link>
                    </li>
                    <li>
                      <Link to="/investor-relations/shareholding-pattern" onClick={handleMenuClick}>
                      Shareholding Pattern
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/investor-relations/policies-programme"
                        onClick={handleMenuClick}
                      >
                         Policies & Programme
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/investor-relations/draft-red-herring-prospectus"
                        onClick={handleMenuClick}
                      >
                        Draft Red Herring Prospectus
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/investor-relations/red-herring-prospectus"
                        onClick={handleMenuClick}
                      >
                        Red Herring Prospectus
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/investor-relations/prospectus"
                        onClick={handleMenuClick}
                      >
                        Prospectus
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/investor-relations/investor-grievance"
                        onClick={handleMenuClick}
                      >
                        Investor Grievance
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/investor-relations/details-of-registrar-and-transfer-agents"
                        onClick={handleMenuClick}
                      >
                        Details of Registrar and Transfer Agents
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/dealers-distributors">Dealers & Distributors</Link>
                </li>*/}

                <li>
                  <a
                    href="https://career.spinoff.in/"
                    onClick={handleMenuClick}
                  >
                    Career
                  </a>
                </li>
                <li>
                  <Link to="/contact-us" onClick={handleMenuClick}>
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/online-payment" onClick={handleMenuClick}>
                    Online Payment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Search Bar */}
            <div id="search">
              <span className="close" />
              <form
                role="search"
                id="searchform"
                action="/search"
                method="get"
                className="radius-xl"
              >
                <div className="input-group">
                  <input
                    defaultValue=""
                    name="q"
                    type="search"
                    placeholder="Type to search"
                  />
                  <span className="input-group-btn">
                    <button type="button" className="search-btn">
                      <i className="fa fa-search arrow-animation" />
                    </button>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
